import { render, staticRenderFns } from "./TransactionFromChain.vue?vue&type=template&id=930b74d4&scoped=true&"
import script from "./TransactionFromChain.vue?vue&type=script&lang=js&"
export * from "./TransactionFromChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930b74d4",
  null
  
)

export default component.exports